import React from 'react';
import lodashGet from 'lodash/get';

import GlTypeIconComponent from '~/components/GlTypeIcon';

const GlTypeIcon = (props: any) => {
  const { record, source = 'glType', ...rest } = props;
  const value = lodashGet(record, source);

  return <GlTypeIconComponent code={value} {...rest} />;
};

export default GlTypeIcon;
